import Captcha from "@Captcha";
import Loader from "@Common/Loader";
import Timer from "@Common/Timer";

import { useHandleResize, useInViewport } from "@hook";
import { getSqlServerGuidHash, updateParamWithoutRerender, clearParamWithoutRerender, isStartScreenWidth, sendMetric, getWhatId, getAbTestMetrika, getCookie, isCaptchaEnabled } from "@utils";

import { checkReachGoalReady } from "@utils";
import { inject, observer } from "mobx-react";
import { useEffect, useLayoutEffect, useState, useRef, Fragment } from "react";
import ListItem from "./ListItem";
import ListItemAccordion from "./ListItemAccordion";

import sberPrimeCoverV2 from "../AB_4031_v2/img/sber_cat.png";
import ListItemV2 from "../AB_4031_v2/ListItem";
import ListItemAccordionV2 from "../AB_4031_v2/ListItemAccordion";
import sberPrimeCoverV3 from "../AB_4031_v3/img/sber_cat.png";
import ListItemV3 from "../AB_4031_v3/ListItem";
import ListItemAccordionV3 from "../AB_4031_v3/ListItemAccordion";

import "./style.scss";

const { VITE_WHAT_ID } = import.meta.env;

const sberPrimeV2 = {
    version: "v2",
    typeLabel: "заберите до 23:59",
    cover: sberPrimeCoverV2,
    ListItem: ListItemV2,
    ListItemAccordion: ListItemAccordionV2,
};
const sberPrimeV3 = {
    version: "v3",
    typeLabel: "заберите до 23:59",
    cover: sberPrimeCoverV3,
    ListItem: ListItemV3,
    ListItemAccordion: ListItemAccordionV3,
};

const SBER_PRIME_VARIANTS = {
    "6ab0e6d13050212bfa64ddf9": sberPrimeV2,
    "6ab0e6d13050212bfa64ddf9_v2": sberPrimeV2,
    "6ab0e74b3050212bfa64deeb": sberPrimeV3,
    "6ab0e74b3050212bfa64deeb_v2": sberPrimeV3,
};

const getModalOffer = (offerItem) => {
    const variant = SBER_PRIME_VARIANTS[offerItem?._id];
    if (!variant) return offerItem;

    const offerOptions = Array.isArray(offerItem.offerOptions) ? offerItem.offerOptions : [];

    return {
        ...offerItem,
        cover: variant.cover,
        typeLabel: variant.typeLabel,
        offerOptions: ["special", ...offerOptions.filter((option) => option !== "special")],
    };
};

const AB_3274 = inject("mainStore")(
    observer(({ mainStore }) => {
        const offersList = mainStore.getMainStore("offersList");
        const isStart = mainStore.getMainStore("isStart");
        const abTest = mainStore.getMainStore("abTest");
        const abTestMetika = mainStore.getMainStore("abTestMetika");
        const wdCd = mainStore.getMainStore("codeTypeMetrika");
        const wdm = mainStore.getMainStore("codeWdm");
        const wd_mc = mainStore.getMainStore("codeWdMc");
        const cookieConsent = mainStore.getMainStore("cookieConsent");
        const isMobile = useHandleResize();

        const offersData = offersList && offersList.offers ? offersList.offers : false;
        const [isAccordionOpen, setIsAccordionOpen] = useState(false);
        const visibleItems = mainStore.getMainStore("visibleItems") ?? 5;

        const cookieValue = getCookie("_rispromo_cookie");
        const observerRef = useRef(null);
        const what_id = getWhatId() ? getWhatId() : VITE_WHAT_ID;

        const urlParams = new URLSearchParams(window.location.search);
        const disableMetrika = urlParams.has("noym");

        useEffect(() => {
            if (mainStore.getMainStore("visibleItems") == null) {
                mainStore.setMainStore("visibleItems", 5);
            }
        }, []);

        for (let i = 0; i < offersData.length; i++) {
            offersData[i].positionIdx = i + 1;
        }

        useEffect(() => {
            const searchParams = new URLSearchParams(location.search);
            const id = searchParams.get("id");

            if (offersData && id) {
                const item = {};
                let idx = 0;
                for (let i = 0; i < offersData.length; i++) {
                    const f = offersData[i];
                    if (f._id == id) {
                        item.offer = f;
                        item.id = i + 1;
                        idx = i;
                    }
                }

                const isAbTestMetrika = getAbTestMetrika(abTest, item?.offer?._id);

                if (item.offer) {
                    if (isStartScreenWidth(820)) {
                        if (!isAccordionOpen) {
                            setTimeout(() => {
                                mainStore.setMainStore("visibleItems", offersData.length); // сразу ставим все офферы, иначе если его не будет в списке из первых 5ти, то не подскролится к нему

                                handleClickMobile(item.offer, isAbTestMetrika, idx + 1); // делаем "клик" по карточке, чтобы сработала механика открытия
                            }, 450);
                        }
                    } else {
                        setTimeout(() => {
                            let type = "offer";
                            if (item.offer?.promoCode) {
                                if (item.offer?.ghostOffer) {
                                    type = "ghost";
                                } else {
                                    type = "promo";
                                }
                            }

                            handelClickDesctop(type, item.offer, isAbTestMetrika, false, idx + 1); // открываем модалку оффера или промо
                        }, 450);
                    }
                }
            }
        }, [offersData]);

        useLayoutEffect(() => {
            if (observerRef.current) {
                const observer = new IntersectionObserver(
                    ([entry]) => {
                        if (entry.isIntersecting) {
                            mainStore.setMainStore("visibleItems", (mainStore.getMainStore("visibleItems") ?? 5) + 5); // Добавляем еще 5 элементов
                        }
                    },
                    {
                        root: null, // Относительно viewport
                        rootMargin: "0px",
                        threshold: 0.1, // Триггер, когда 10% элемента видно
                    },
                );

                observer.observe(observerRef.current);

                return () => {
                    observer.unobserve(observerRef.current);
                };
            }
        }, []);

        useEffect(() => {
            if (isStart) return;

            if (!disableMetrika) {
                sendMetric(`show_showcase`, {
                    params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                    params2: null,
                    params3: null,
                    params4: null,
                    params6: null,
                    params7: null,
                    params8: what_id,
                });

                checkReachGoalReady().then(() => {
                    window.risMetrika.reachgoal_ch({
                        event: "show_showcase",
                        siteId: what_id, //'id витрины',
                        session_uuid: localStorage.getItem("_r_p_s"),
                        widget_code: wdCd ? wdCd : "",
                        ml_traffic_mode: wdm ? wdm : "",
                        ml_model_code: wd_mc ? wd_mc : "",
                    });
                });
            }
        }, [isStart]);

        useEffect(() => {
            window.addEventListener("scroll", handleScroll);
            return () => window.removeEventListener("scroll", handleScroll);
        }, [cookieConsent]);

        const handleScroll = (e) => {
            let elem = document.getElementById("timer");
            let bgTimer = document.getElementById("bg-timer");

            if (!elem || !bgTimer) return;

            if (e.target.scrollingElement.scrollTop >= 172) {
                if (!cookieValue) {
                    elem.classList.add("fixed_bottom");
                }
                elem.classList.add("fixed");

                bgTimer.style.display = "block";
            } else {
                bgTimer.style.display = "none";
                elem.classList.remove("fixed");
                elem.classList.remove("fixed_bottom");
            }
        };

        useInViewport(
            [".list-item  ", ".list-item__accordion  ", ".ab-list-item__accordion", ".ab-1029-list-item__accordion", ".ab-list-item"],
            async (resp) => {
                let visibleOffer = null;
                for (let i = 0; i < offersData.length; i++) {
                    if (offersData[i]._id == resp.id) {
                        visibleOffer = { ...offersData[i] };
                        break;
                    }
                }

                const isAbTestMetrika = getAbTestMetrika(abTest, visibleOffer?._id);

                sendMetric(`${visibleOffer.promoCode ? "front_show_got_offer" : "show_offer"}`, {
                    params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                    params2: visibleOffer?._id,
                    params3: getSqlServerGuidHash(visibleOffer?.code, visibleOffer?.vendor?._id),
                    params4: visibleOffer?.code ?? null,
                    params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                    params7: null,
                    params8: what_id,
                });

                if (window.risMetrika && typeof window.risMetrika.reachgoal_ch === "function" && visibleOffer) {
                    window.risMetrika.reachgoal_ch({
                        event: `${visibleOffer.promoCode ? "front_show_got_offer" : "front_show_offer"}`,
                        siteId: what_id, //'id витрины',
                        offerId: visibleOffer?._id, //'id оффера'
                        variantCode: visibleOffer?._ab_code, //'в оффере новый ключ _ab_code',
                        position: visibleOffer?.positionIdx, //'Позиция оффера на витрине, не путать с сортировкой!!!' ,
                        sort: visibleOffer?.sortNum, //'Сортировка оффера на витрине!!!' ,
                        session_uuid: localStorage.getItem("_r_p_s"),
                        widget_code: wdCd ? wdCd : "",
                        ml_traffic_mode: wdm ? wdm : "",
                        ml_model_code: wd_mc ? wd_mc : "",
                    });
                }
            },
            isStart && offersData.length,
            offersData.length, //нужна одна зависимость из 2х ключей
        );

        const handleClickItem = async (offerItem, idx = 0) => {
            mainStore.setMainStore("formQuestionsChain", []);

            const isAbTestMetrika = getAbTestMetrika(abTest, offerItem?._id);

            if (offerItem.offerTypeCPC) {
                handleGetPromo(offerItem, idx + 1);
                return;
            } // дальше не выполняем код, т.к. это офер cpc

            mainStore.setMainStore("indexPositionMetrik", idx + 1);

            if (isMobile) {
                handleClickMobile(offerItem, isAbTestMetrika, idx + 1);
                handleFocusOnMobile(offerItem);
                document.body.style.cssText += `overflow-y: scroll`;
            } else {
                handelClickDesctop("offer", offerItem, isAbTestMetrika, false, idx + 1);
            }

            clearParamWithoutRerender(["noym"]);
        };

        const handleFocusOnMobile = (offerItem) => {
            const close = isAccordionOpen._id === offerItem._id;

            if (!isAccordionOpen._id || isAccordionOpen._id !== offerItem._id) {
                const oldInput = document.querySelector(".list-item__hidden-input");
                if (oldInput) {
                    oldInput.blur();
                    oldInput.remove();
                }
                if (offerItem.inputFields?.length > 0 && !offerItem.surveyId && !offerItem.promoCode) {
                    const input = document.createElement("input");
                    input.className = "list-item__hidden-input";

                    document.body.appendChild(input);
                    input.focus({ preventScroll: true });
                }
            }

            if (close) {
                const oldInput = document.querySelectorAll(".list-item__hidden-input");
                oldInput.forEach((el) => {
                    el.blur();
                    el.remove();
                });
            }
        };

        const handleClickCpa = (offerItem, isAbTestMetrika, idx) => {
            sendMetric(`click_offer`, {
                params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                params2: offerItem?._id,
                params3: getSqlServerGuidHash(offerItem.code, offerItem.vendor?._id),
                params4: offerItem?.code,
                params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                params7: null,
                params8: what_id,
            });
            if (window.risMetrika && typeof window.risMetrika.reachgoal_ch === "function") {
                window.risMetrika.reachgoal_ch({
                    event: "click_offer",
                    siteId: what_id, //'id витрины',
                    offerId: offerItem?._id, //'id оффера'
                    variantCode: offerItem?._ab_code, //'в оффере новый ключ _ab_code',
                    position: offerItem?.positionIdx, //'Позиция оффера на витрине, не путать с сортировкой!!!' ,
                    sort: offerItem?.sortNum, //'Сортировка оффера на витрине!!!' ,
                    session_uuid: localStorage.getItem("_r_p_s"),
                    widget_code: wdCd ? wdCd : "",
                    ml_traffic_mode: wdm ? wdm : "",
                    ml_model_code: wd_mc ? wd_mc : "",
                });
            }
            sendMetric(`get_promo`, {
                params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                params2: offerItem?._id,
                params3: getSqlServerGuidHash(offerItem.code, offerItem.vendor?._id),
                params4: offerItem?.code,
                params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                params7: null,
                params8: what_id,
            });
            if (window.risMetrika && typeof window.risMetrika.reachgoal_ch === "function") {
                window.risMetrika.reachgoal_ch({
                    event: "get_promo",
                    siteId: what_id, //'id витрины',
                    offerId: offerItem?._id, //'id оффера'
                    variantCode: offerItem?._ab_code, //'в оффере новый ключ _ab_code',
                    position: idx ? idx + 1 : 1, //'Позиция оффера на витрине, не путать с сортировкой!!!' ,
                    sort: offerItem?.sortNum, //'Сортировка оффера на витрине!!!' ,
                    session_uuid: localStorage.getItem("_r_p_s"),
                    widget_code: wdCd ? wdCd : "",
                    ml_traffic_mode: wdm ? wdm : "",
                    ml_model_code: wd_mc ? wd_mc : "",
                });
            }

            if (!localStorage.getItem("first_get_promo")) {
                sendMetric(`first_get_promo`, {
                    params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                    params2: offerItem?._id,
                    params3: getSqlServerGuidHash(offerItem.code, offerItem.vendor?._id),
                    params4: offerItem?.code,
                    params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                    params7: null,
                    params8: what_id,
                });
                localStorage.setItem("first_get_promo", true);
            }

            if (!localStorage.getItem("first_click_offer")) {
                sendMetric(`first_click_offer`, {
                    params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                    params2: offerItem?._id,
                    params3: getSqlServerGuidHash(offerItem.code, offerItem.vendor?._id),
                    params4: offerItem?.code,
                    params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                    params7: null,
                    params8: what_id,
                });
                localStorage.setItem("first_click_offer", true);
            }

            const obj = {
                offerId: offerItem._id,
                positionOffer: idx,
                abOfferCode: offerItem._ab_code,
                sortOffer: offerItem.sortNum,
            };

            mainStore.getByUrl("/app_rispromo/offer_item", obj, false, "", false);
            setIsAccordionOpen(false);
            clearParamWithoutRerender(["id", "code"]);
            mainStore.setMainStore("modal", { type: "cpc", offerItem: offerItem });
        };

        const handleClickMobile = async (offerItem, isAbTestMetrika, idx) => {
            let newOffer = JSON.parse(JSON.stringify(offerItem));

            mainStore.setMainStore("promoIdCity", false);
            mainStore.setMainStore("promoIdRegion", false);
            mainStore.setMainStore("promoIdMetro", false);

            if (isAccordionOpen._id === offerItem._id) {
                clearParamWithoutRerender(["id", "code"]);

                newOffer = false;

                if (!localStorage.getItem("first_click_offer_close")) {
                    sendMetric(`first_click_offer_close`, {
                        params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                        params2: offerItem?._id,
                        params3: getSqlServerGuidHash(offerItem.code, offerItem.vendor?._id),
                        params4: offerItem?.code,
                        params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                        params7: null,
                        params8: what_id,
                    });

                    localStorage.setItem("first_click_offer_close", true);
                }

                if (offerItem.promoCode) {
                    sendMetric(`click_offer_accepted_close`, {
                        params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                        params2: offerItem?._id,
                        params3: getSqlServerGuidHash(offerItem.code, offerItem.vendor?._id),
                        params4: offerItem?.code,
                        params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                        params7: null,
                        params8: what_id,
                    });
                } else {
                    sendMetric(`click_offer_close`, {
                        params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                        params2: offerItem?._id,
                        params3: getSqlServerGuidHash(offerItem.code, offerItem.vendor?._id),
                        params4: offerItem?.code,
                        params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                        params7: null,
                        params8: what_id,
                    });
                }
            } else {
                const obj = {
                    offerId: offerItem._id,
                    positionOffer: idx,
                    abOfferCode: offerItem._ab_code,
                    sortOffer: offerItem.sortNum,
                };

                mainStore.getByUrl("/app_rispromo/offer_item", obj, false, "", false);

                const params = [
                    { key: "id", val: offerItem._id },
                    { key: "code", val: offerItem.code },
                ];

                params.forEach((el) => updateParamWithoutRerender(el.key, el.val));

                if (offerItem.promoCode) {
                    if (!disableMetrika) {
                        sendMetric(`click_offer_accepted`, {
                            params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                            params2: offerItem?._id,
                            params3: getSqlServerGuidHash(offerItem.code, offerItem.vendor?._id),
                            params4: offerItem?.code,
                            params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                            params7: null,
                            params8: what_id,
                        });
                    }
                } else {
                    if (offerItem.surveyId) {
                        let offerFormTemplate = await handleFormTemplateOfferGet(offerItem.surveyId, offerItem);
                        if (offerFormTemplate) {
                            newOffer = offerFormTemplate;
                        }
                    } else {
                        newOffer = offerItem;
                    }

                    if (offerItem.addressId) {
                        let offerAddress = await handleFilialGet(offerItem.addressId, offerItem);
                        if (offerAddress) {
                            newOffer = offerAddress;
                        }
                    } else {
                        newOffer = offerItem;
                    }

                    sendMetric(`click_offer`, {
                        params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                        params2: offerItem?._id,
                        params3: getSqlServerGuidHash(offerItem.code, offerItem.vendor?._id),
                        params4: offerItem?.code,
                        params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                        params7: null,
                        params8: what_id,
                    });
                    if (window.risMetrika && typeof window.risMetrika.reachgoal_ch === "function") {
                        window.risMetrika.reachgoal_ch({
                            event: "click_offer",
                            siteId: what_id, //'id витрины',
                            offerId: offerItem?._id, //'id оффера'
                            variantCode: offerItem?._ab_code, //'в оффере новый ключ _ab_code',
                            position: offerItem?.positionIdx, //'Позиция оффера на витрине, не путать с сортировкой!!!' ,
                            sort: offerItem?.sortNum, //'Сортировка оффера на витрине!!!' ,
                            session_uuid: localStorage.getItem("_r_p_s"),
                            widget_code: wdCd ? wdCd : "",
                            ml_traffic_mode: wdm ? wdm : "",
                            ml_model_code: wd_mc ? wd_mc : "",
                        });
                    }
                }

                if (!localStorage.getItem("first_click_offer")) {
                    sendMetric(`first_click_offer`, {
                        params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                        params2: offerItem?._id,
                        params3: getSqlServerGuidHash(offerItem.code, offerItem.vendor?._id),
                        params4: offerItem?.code,
                        params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                        params7: null,
                        params8: what_id,
                    });
                    localStorage.setItem("first_click_offer", true);
                }
            }

            setIsAccordionOpen(newOffer);
        };

        const handelClickDesctop = async (type, offerItem, isAbTestMetrika, open = false, idx) => {
            const obj = {
                offerId: offerItem._id,
                positionOffer: idx,
                abOfferCode: offerItem._ab_code,
                sortOffer: offerItem.sortNum,
            };

            mainStore.getByUrl("/app_rispromo/offer_item", obj, false, "", false);
            const params = [
                { key: "id", val: offerItem._id },
                { key: "code", val: offerItem.code },
            ];
            params.forEach((el) => updateParamWithoutRerender(el.key, el.val));
            if (offerItem.promoCode) {
                if (offerItem.ghostOffer) {
                    type = "ghost";
                } else {
                    type = "promo";
                }

                if (!disableMetrika) {
                    sendMetric(`click_offer_accepted`, {
                        params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                        params2: offerItem?._id,
                        params3: getSqlServerGuidHash(offerItem.code, offerItem.vendor?._id),
                        params4: offerItem?.code,
                        params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                        params7: null,
                        params8: what_id,
                    });
                }
            } else {
                sendMetric(`click_offer`, {
                    params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                    params2: offerItem?._id,
                    params3: getSqlServerGuidHash(offerItem.code, offerItem.vendor?._id),
                    params4: offerItem?.code,
                    params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                    params7: null,
                    params8: what_id,
                });
                if (window.risMetrika && typeof window.risMetrika.reachgoal_ch === "function") {
                    window.risMetrika.reachgoal_ch({
                        event: "click_offer",
                        siteId: what_id, //'id витрины',
                        offerId: offerItem?._id, //'id оффера'
                        variantCode: offerItem?._ab_code, //'в оффере новый ключ _ab_code',
                        position: offerItem?.positionIdx, //'Позиция оффера на витрине, не путать с сортировкой!!!' ,
                        sort: offerItem?.sortNum, //'Сортировка оффера на витрине!!!' ,
                        session_uuid: localStorage.getItem("_r_p_s"),
                        widget_code: wdCd ? wdCd : "",
                        ml_traffic_mode: wdm ? wdm : "",
                        ml_model_code: wd_mc ? wd_mc : "",
                    });
                }
            }
            if (offerItem.addressId) {
                await handleFilialGet(offerItem.addressId, offerItem);
            }

            if (offerItem.surveyId) {
                let offerFormTemplate = await handleFormTemplateOfferGet(offerItem.surveyId, offerItem);
                if (offerFormTemplate) {
                    mainStore.setMainStore("modal", { type, offerItem: getModalOffer(offerFormTemplate) });
                }
            } else {
                mainStore.setMainStore("modal", { type, offerItem: getModalOffer(offerItem) });

                if (!localStorage.getItem("first_click_offer")) {
                    sendMetric(`first_click_offer`, {
                        params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                        params2: offerItem?._id,
                        params3: getSqlServerGuidHash(offerItem.code, offerItem.vendor?._id),
                        params4: offerItem?.code,
                        params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                        params7: null,
                        params8: what_id,
                    });
                    localStorage.setItem("first_click_offer", true);
                }
            }
        };

        const handleFilialGet = async (id, offerItem) => {
            const resp = await mainStore.getByUrl("app_rispromo/offer_adresses", { fid: id }, false, "", false);
            if (resp && resp.success) {
                offerItem.addresses = resp.data;
                return offerItem;
            }
            return false;
        };

        const handleFormTemplateOfferGet = async (idOffer, it) => {
            const form_questions = mainStore.getMainStore("form_questions");
            const qItem = form_questions?.[idOffer];
            if (qItem) {
                const map = {};
                const usedIds = new Set();
                qItem.questionsArray.forEach((item) => (map[item._id] = { ...item, children: [] }));

                qItem.questionsArray.forEach((item) => {
                    if (item.options && Array.isArray(item.options)) {
                        item.options.forEach((option) => {
                            if (option.relaitedId && map[option.relaitedId]) {
                                map[item._id].children.push(map[option.relaitedId]);
                                usedIds.add(option.relaitedId);
                            }
                        });
                    }
                });
                const result = qItem.questionsArray.filter((item) => !usedIds.has(item._id)).map((item) => map[item._id]);

                it.formTemplate = result;
                return it;
            }
            return false;
        };

        const handleGetPromo = (offerItem, idx) => {
            const cap_token = mainStore.getMainStore("capToken"); // забираем полученный токен при включении формы
            const captcha = mainStore.getMainStore("captcha"); // забираем полученный токен при включении формы

            if (!isCaptchaEnabled || (cap_token && cap_token != "qwerty" && !captcha)) {
                const isAbTestMetrika = getAbTestMetrika(abTest, offerItem?._id);
                handleClickCpa(offerItem, isAbTestMetrika, idx); // идем на запрос промо с текущим токеном
            } else {
                mainStore.setMainStore("captcha", `captcha_${offerItem._id}`); // включаем капчу в форме и получаем новый токен
            }
        };

        const handleHiddenCaptcha = () => mainStore.setMainStore("captcha", false);

        return (
            <div className={`ab-3274 list ${!offersData ? "head" : ""}`}>
                {/* {!isStart && <Timer />}
                <div className="lazy__block_bg-timer" id="bg-timer" />
                <div className="lazy__block_bg-timer_mobile" /> */}

                <div className={`list__block `} id="list__block">
                    {!offersData ? (
                        <Loader />
                    ) : (
                        offersData.slice(0, visibleItems).map((it, idx) => {
                            const itType = it.offerOptions?.find((f) => !ignoredTypes.includes(f));
                            const sberPrimeVariant = SBER_PRIME_VARIANTS[it._id];
                            const ItemComponent = sberPrimeVariant?.ListItem || ListItem;
                            const AccordionComponent = sberPrimeVariant?.ListItemAccordion || ListItemAccordion;
                            const isSberPrime = Boolean(sberPrimeVariant);
                            return (
                                <Fragment key={it._id}>
                                    {it.offerTypeCPC && <Captcha onSuccess={() => handleGetPromo(it)} onChallengeHidden={handleHiddenCaptcha} id={`captcha_${it._id}`} />}

                                    {isMobile ? (
                                        <AccordionComponent
                                            item={it}
                                            id={idx}
                                            handleClick={() => handleClickItem(it, idx)}
                                            setIsAccordionOpen={setIsAccordionOpen}
                                            isAccordionOpen={isAccordionOpen}
                                            title={it.title}
                                            cover={it?.coverMobile || it?.vendor?.squareLogo || ""}
                                            category={it?.vendor?.category?.[0]?.title}
                                            type={isSberPrime ? "hit" : itType}
                                            typeLabel={sberPrimeVariant?.typeLabel || "хит"}
                                            isSberPrime={isSberPrime}
                                        />
                                    ) : (
                                        <ItemComponent
                                            item={it}
                                            idx={idx}
                                            id={it._id}
                                            handleClick={() => handleClickItem(it, idx)}
                                            title={it.title}
                                            cover={it.cover || it.vendor?.logoList}
                                            category={it?.vendor?.category?.[0]?.title}
                                            type={isSberPrime ? "hit" : itType}
                                            typeLabel={sberPrimeVariant?.typeLabel || "хит"}
                                            isSberPrime={isSberPrime}
                                        />
                                    )}
                                </Fragment>
                            );
                        })
                    )}
                    <div id="list-sentinel" ref={observerRef} />
                </div>
            </div>
        );
    }),
);

export default AB_3274;

const ignoredTypes = ["isEndDate", "redirect"];
